/* @flow */

import {unexpectedCase} from 'nutshell-core/reducer-utils';

export type AiAgentState = {|
    entityId: string | null,
    pageInfo: string | null,
    entityName: string | null,
|};

type AiAgentAction = {|
    type: string,
    payload: AiAgentState,
|};

const SET_AGENT_CONTEXT = 'SET_AGENT_CONTEXT';

export const setAgentContext = (entityId: ?string, pageInfo: ?string, entityName: ?string) => ({
    type: SET_AGENT_CONTEXT,
    payload: {entityId, pageInfo, entityName},
});

const initialState = {
    entityId: null,
    pageInfo: null,
    entityName: null,
};

export const aiAgentReducer = (state: AiAgentState = initialState, action: AiAgentAction) => {
    switch (action.type) {
        case SET_AGENT_CONTEXT:
            return {
                ...state,
                entityId: action.payload.entityId,
                pageInfo: action.payload.pageInfo,
                entityName: action.payload.entityName,
            };
        default:
            unexpectedCase(null);

            return state;
    }
};
